import { Grid } from '@mui/material';
import { ProjectPathParams, Paths } from '../../../../../app/router/app.router';
import {
  PageHeaderGrid,
  PageHeaderWrapper,
  Subtitle,
  Title
} from '../../../../../ui/components/pure/page-header/page-header.component';
import { TeamMembersListControlsState } from '../../../team.queries';
import { TeamMembersListControls } from '../team-members-list-controls/team-members-list-controls.component';
import { useTeamMembersList } from '../../hooks/use-team-members-list.hook';

interface TeamMembersListHeaderProps {
  formData: TeamMembersListControlsState;
  setFormData: (update: Partial<TeamMembersListControlsState>) => void;
  params: ProjectPathParams<Paths.team>;
  projectName?: string;
  actions: ReturnType<typeof useTeamMembersList>['actions'];
  statusOptions: { label: string; value: string }[];
}

export function TeamMembersListHeader({
  params,
  projectName,
  formData,
  setFormData,
  actions,
  statusOptions
}: TeamMembersListHeaderProps) {
  return (
    <PageHeaderWrapper>
      <Grid container spacing={2}>
        <PageHeaderGrid size={{ sm: 12, md: 6 }} alignItems="flex-start">
          <Title text="Team Members" />
          <Subtitle text={projectName ? `Grant access to your team at ${projectName}` : ''} />
        </PageHeaderGrid>
        <PageHeaderGrid size={{ sm: 12, md: 6 }} alignItems="flex-start">
          <TeamMembersListControls
            params={params}
            formData={formData}
            setFormData={setFormData}
            actions={actions}
            statusOptions={statusOptions}
          />
        </PageHeaderGrid>
      </Grid>
    </PageHeaderWrapper>
  );
}
